<template>
  <div class="grades-list flickity-container">
    <flickity class="flickity carousel" ref="flickity" @init="onInit" :options="flickityOptions">
      <GradesItem
        v-for="(gradesList, gradesLabel) in grades"
        :key="gradesLabel"
        :gradesLabel="gradesLabel"
        :grades="gradesList"
      />
    </flickity>
  </div>
</template>

<script>
import GradesItem from '@/components/GradesList/GradesItem.vue';

export default {
  components: {
    GradesItem,
  },
  props: {
    grades: Object,
  },
  data() {
    return {
      flickityOptions: {
        cellAlign: 'left',
        percentPosition: false,
        pageDots: false,
        watchCSS: true,
      },
    };
  },
  methods: {
    onInit() {},
  },
};
</script>

<style lang="scss">
.grades-list{
  .flickity-button {
    background: transparent;
  }

  .flickity-prev-next-button {
    width: 30px;
    height: 30px;
    border-radius: 0;
  }

  .flickity-prev-next-button.previous,
  .flickity-prev-next-button.next {
    top: 50%;
    display: block;
    width: 40px;
    height: 40px;
    opacity: 1;
    svg {
      display: none;
    }
  }

  .flickity-prev-next-button.previous {
    left: -65px;
    transform: rotate(-45deg);
    transition: 0.5s opacity;
    &:hover {
      &:before {
        transform: translate(-6px, -6px);
      }
      &:after {
        transform: rotate(-45deg) translate(16px, -6px);
      }
    }
  }

  .flickity-prev-next-button.next {
    right: -65px;
    transform: rotate(135deg);
    transition: 0.5s opacity;
    &:hover {
      &:before {
        transform: translate(-6px, -6px);
      }
      &:after {
        transform: rotate(-45deg) translate(16px, -6px);
      }
    }
  }

  .flickity-prev-next-button.next::before,
  .flickity-prev-next-button.previous::before{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 25px;
    height: 25px;
    border-top: 3px solid #1b181a;
    border-left: 3px solid #1b181a;
    opacity: 1;
    transition: 0.5s transform;
  }
  .flickity-prev-next-button.next::after,
  .flickity-prev-next-button.previous::after{
    @apply bg-black;
    content: "";
    position: absolute;
    display: block;
    width: 3px;
    height: 48px;
    transform: rotate(-45deg) translate(16px, 4px);
    left: 4px;
    top: 4px;
    transition: 0.5s transform;
  }

  .flickity-button:disabled {
    opacity: 0;
  }

  .flickity-button:hover {
    background: transparent;
  }
}
</style>

<style lang="scss" scoped>

.flickity-container {
  @apply mt-8 relative;
  @media screen and (min-width: 992px) {
    @apply px-0;
    margin-left: -1rem;
  }
  .carousel:after {
    content: "";
    @media screen and (min-width: 992px) {
      content: "flickity";
      display: none;
    }
  }

  .carousel-cell {
    @apply flex flex-col justify-start items-center w-full text-base no-underline cursor-pointer;
    border-radius: 15px;
    @media screen and (min-width: 992px) {
      @apply w-1/2 justify-center items-start px-4;
    }
    @media screen and (min-width: 1500px) {
      @apply w-1/3;
    }
    & + .carousel-cell {
      @apply mt-6;
      @media screen and (min-width: 992px) {
        @apply mt-0;
      }
    }
    span {
      @apply leading-tight;
      @media screen and (min-width: 992px) {
        @apply text-lg;
      }
    }
  }
}
.grades-list{
  @media screen and (min-width: 992px) {
    margin-left: 40px;
    margin-right: 78px;
  }
}
</style>
